// #region Import
import core_debounce from 'lodash/debounce';
// #endregion
export default class DeviceHelper {
    // #region Vars
    listeners;
    // #endregion
    // #region Constructor
    constructor() {
        //Vars
        this.listeners = new Array();
        //System
        window.addEventListener('resize', core_debounce(() => {
            this.listeners.forEach((listenerObject) => {
                listenerObject.listener.call(listenerObject.scope, event);
            });
        }, 100));
    }
    // #endregion
    // #region Resize
    onResize({ listener, scope, component }) {
        if (!scope) {
            scope = window;
        }
        this.listeners.push({ listener, scope, component });
        return this.listeners.length - 1;
    }
    removeResizeListener(component) {
        this.listeners = this.listeners.filter((listenerObject) => {
            return component !== listenerObject.component;
        });
        return true;
    }
    // #endregion
    // #region Tools
    getUserAgent() {
        return window.navigator.userAgent;
    }
    getViewportWidth() {
        return window.innerWidth;
    }
    getViewportHeight() {
        return window.innerHeight;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getScreenWidth() {
        return window.screen.width;
    }
    getScreenHeight() {
        return window.screen.height;
    }
    getScreenOrientation() {
        return window.screen.orientation;
    }
    getBrowserLanguage() {
        return window.navigator.language;
    }
    getPlatform() {
        return window.navigator.platform;
    }
    getSystemKey() {
        return this.getPlatform().indexOf('Mac') > -1 ? 'CTRL' : 'ALT';
    }
}
